export default __webpack_public_path__ + "static/media/(18).b02605e8.jpg";